import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { footwearMaterialColumns } from "../../FootwearMaterialMaster/data";

export const fabricCodeSearchColumn = {
	name: "Fabric Id",
	key: "fabric_id",
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	[selectOptionsKeyName]: {
		type: arrType,
		list: [],
		getOptionLabel: (item) => ({ name: item?.fabric_code, key: item?.fabric_code }),
	},
};
export const fwMaterialCodeSearchColumn = {
	name: "Material Id",
	key: "fw_material_code",
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	[selectOptionsKeyName]: {
		type: arrType,
		list: [],
		getOptionLabel: (item) => ({
			name: item?.[footwearMaterialColumns.fw_material_code.key],
			key: item?.[footwearMaterialColumns.fw_material_code.key],
		}),
	},
};
export const sourcingOptionCogsColumn = {
	name: "COGS",
	key: "cogs",
	input_type: inputTypes.ENTER.key,
	data_type: datatypes.NUMBER.key,
	editable: true,
};
export const washCareColumn = {
	name: "Wash Care",
	key: "wash_care",
	input_type: inputTypes.ENTER.key,
	data_type: datatypes.STRING.key,
	editable: true,
	default_value: "",
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
};

export const finalMRPColumn = {
	name: "Final MRP",
	key: "final_mrp",
	input_type: inputTypes.ENTER.key,
	data_type: datatypes.NUMBER.key,
	editable: true,
	default_value: 0,
};
export const hsnCodeColumn = {
	name: "HSN Code",
	key: "hsn_code",
	input_type: inputTypes.ENTER.key,
	data_type: datatypes.STRING.key,
	editable: true,
	default_value: "",
};
